import { track as trackRequest } from '@pocket/web-utilities/legacy-analytics'
import { CONSUMER_KEY } from '../constants'

export const legacyAnalyticsTrack = (params) => {
  return trackRequest(CONSUMER_KEY, params)
}
